export const INACTIVE_CATEGORY_ID = '77d2fdc6-aeb4-41ea-bb9e-6234cd6b494a';
export const EXCLUDED_FROM_DATA_EXTRACTION_CATEGORY_ID = '591416cf-eee1-4126-9970-a15fb27867ab';

export const CATEGORY_DOCS_DEFAULT_HEIGHT = 280;
export const DEFAULT_DOC_TYPES_NUMBER = 3;

export const SystemCategoryIdList = [
  INACTIVE_CATEGORY_ID,
  EXCLUDED_FROM_DATA_EXTRACTION_CATEGORY_ID,
];

export const EXCLUDED_FROM_DATA_EXTRACTION_DOCUMENT_CATEGORY = {
  documentCategoryId: EXCLUDED_FROM_DATA_EXTRACTION_CATEGORY_ID,
  documentCategoryName: 'Excluded from data extraction',
  orderNumber: 9999998,
  isSystemCategory: true,
};

export const INACTIVE_DOCUMENT_CATEGORY = {
  documentCategoryId: INACTIVE_CATEGORY_ID,
  documentCategoryName: 'Inactive',
  orderNumber: 9999999,
  isSystemCategory: true,
};

export const MOVE_TO_INACTIVE_CATEGORY_MESSAGE =
  'Inactive document type will be removed from bundle document type list';
